import {
  Comment,
  CommentRaw,
  Dislike,
  Evaluation,
  Like,
} from '../../types/comment'

export const convertCommentRawToComment = (commentRaw: CommentRaw): Comment => {
  const comment: Comment = {
    id: commentRaw._id,
    text: commentRaw.text,
    author: commentRaw.author,
    book: commentRaw.book,
    createdAt: commentRaw.createdAt,
    likes: commentRaw?.evaluations?.filter(
      (evaluation: Evaluation) => evaluation.value === 'like',
    ) as Like[],
    dislikes: commentRaw?.evaluations?.filter(
      (evaluation: Evaluation) => evaluation.value === 'dislike',
    ) as Dislike[],
  }

  return comment
}
